import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalApiService } from 'src/app/shared-modules/global-api.service';
import { AuthService } from 'src/app/shared-modules/services/auth.service';
import { Observable, observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class RatingModuleService {

  constructor(
    private http: HttpClient,
    private globalApiService: GlobalApiService,
    private authService: AuthService
  ) { }

  getGYMFeedback(postObj): Observable<any> {
    return this.http.post(this.globalApiService.getApiUrl() + '/salesUser/addfeedback', postObj)
        .pipe(catchError((e: any) => this.authService.getCheckError(e)));
}


}
